import React, { useEffect, useState } from 'react';
import api from '../services/api';
import Toast from '../components/Toast';
import FilterableTable from '../components/FilterableTable';

export default function Utilizatori() {
  const [utilizatori, setUtilizatori] = useState([]);
  const [magazii, setMagazii] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [form, setForm] = useState({ email: '', nume: '', rol: 'operator', magazii: [] });
  const [parolaGenerata, setParolaGenerata] = useState(null);
  const [toast, setToast] = useState(null);
  const [loading, setLoading] = useState(true);

  function incarca() {
    setLoading(true);
    Promise.all([api.get('/api/admin/utilizatori'), api.get('/api/magazii')])
      .then(([u, g]) => { setUtilizatori(u.data); setMagazii(g.data); })
      .finally(() => setLoading(false));
  }

  useEffect(incarca, []);

  function toggleMagazie(id) {
    const magazii2 = form.magazii.includes(id) ? form.magazii.filter(m => m !== id) : [...form.magazii, id];
    setForm({ ...form, magazii: magazii2 });
  }

  async function salveaza(e) {
    e.preventDefault();
    try {
      const res = await api.post('/api/admin/utilizatori', form);
      setParolaGenerata({ email: form.email, parola: res.data.parolaInitiala });
      setShowModal(false);
      setForm({ email: '', nume: '', rol: 'operator', magazii: [] });
      incarca();
    } catch (err) {
      setToast({ message: err.response?.data?.error || 'Eroare la creare cont', type: 'error' });
    }
  }

  async function dezactiveaza(id) {
    if (!window.confirm('Dezactivezi acest utilizator?')) return;
    await api.delete(`/api/admin/utilizatori/${id}`);
    incarca();
  }

  const coloane = [
    { key: 'email', label: 'Email' },
    { key: 'nume', label: 'Nume' },
    { key: 'rol', label: 'Rol' },
    { key: 'magazii', label: 'Magazii alocate' },
    { key: 'activ', label: 'Status', render: u => <span className={`badge ${u.activ ? 'ok' : 'alerta'}`}>{u.activ ? 'Activ' : 'Inactiv'}</span> },
    { key: 'actiuni', label: '', filterable: false, render: u => (
      u.activ ? <button className="btn-delete" onClick={() => dezactiveaza(u.id)}>Dezactiveaza</button> : null
    ) }
  ];

  return (
    <div>
      <h1>Utilizatori</h1>
      <div className="toolbar">
        <button className="btn-add" onClick={() => setShowModal(true)}>+ Utilizator nou</button>
      </div>

      {loading ? <p>Se incarca...</p> : <FilterableTable columns={coloane} rows={utilizatori} />}

      {showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal" onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <h2>Utilizator nou</h2>
              <button type="button" className="modal-close" onClick={() => setShowModal(false)}>&times;</button>
            </div>
            <form onSubmit={salveaza}>
              <div className="modal-body">
                <div className="field-row">
                  <div className="field">
                    <label>Email *</label>
                    <input type="email" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} required autoFocus />
                  </div>
                  <div className="field">
                    <label>Nume</label>
                    <input value={form.nume} onChange={e => setForm({ ...form, nume: e.target.value })} />
                  </div>
                </div>
                <div className="field">
                  <label>Rol</label>
                  <select value={form.rol} onChange={e => setForm({ ...form, rol: e.target.value })}>
                    <option value="operator">Operator</option>
                    <option value="admin">Admin</option>
                  </select>
                </div>
                <div className="field">
                  <label>Magazii alocate</label>
                  {magazii.map(g => (
                    <label key={g.id} style={{ display: 'block', fontSize: 14, fontWeight: 'normal' }}>
                      <input type="checkbox" checked={form.magazii.includes(g.id)}
                        onChange={() => toggleMagazie(g.id)} style={{ width: 'auto', marginRight: 8 }} />
                      {g.nume}
                    </label>
                  ))}
                </div>
              </div>
              <div className="modal-actions">
                <button type="button" className="btn secondary" onClick={() => setShowModal(false)}>Anuleaza</button>
                <button type="submit" className="btn">Creeaza cont</button>
              </div>
            </form>
          </div>
        </div>
      )}

      {parolaGenerata && (
        <div className="modal-overlay" onClick={() => setParolaGenerata(null)}>
          <div className="modal" style={{ width: 315 }} onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <h2>Cont creat</h2>
              <button type="button" className="modal-close" onClick={() => setParolaGenerata(null)}>&times;</button>
            </div>
            <div className="modal-body">
              <p style={{ marginTop: 0 }}>Transmite aceste date lui <strong>{parolaGenerata.email}</strong>:</p>
              <p>Parola initiala: <code style={{ fontSize: 16, background: '#f0f1f3', padding: '4px 8px', borderRadius: 4 }}>{parolaGenerata.parola}</code></p>
            </div>
            <div className="modal-actions">
              <button className="btn" onClick={() => setParolaGenerata(null)}>Am notat</button>
            </div>
          </div>
        </div>
      )}

      <Toast message={toast?.message} type={toast?.type} onClose={() => setToast(null)} />
    </div>
  );
}
